import React from 'react'
import './src/styles/global.scss'
import rollbar from './src/globals/rollbar'
import { getQueue, initializeQueue } from './src/globals/queue'
import PageWrapper from './src/components/page-wrapper'

if (typeof window !== `undefined`) {
  window.Rollbar = rollbar
}

if (typeof window !== `undefined`) {
  initializeQueue();
  window.getPerspectiveQueue = getQueue
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <PageWrapper
      {...props}
      element={element}
    />
  )
}
